export default __webpack_public_path__ + "static/media/74_desktop.f2efee74.jpg";